import { useCallback, useRef } from "react"
import { useAuth } from "../../contexts/AuthContext"
import {
    requestPermission,
    getExistingToken,
    getCurrentToken,
} from "./firebase"
import { saveDeviceToken } from "./notificationService"

export default function useNotificationPrompt() {
    const { auth } = useAuth()
    const prompted = useRef(false)

    const promptAndSaveToken = useCallback(async () => {
        if (!auth?.token) return

        // Already granted — silently get and save token
        if ("Notification" in window && Notification.permission === "granted") {
            try {
                const token = getCurrentToken() || (await getExistingToken())
                if (token) {
                    await saveDeviceToken({
                        token,
                        accessToken: auth.token,
                    })
                }
            } catch (error) {
                console.error("Failed to save existing device token:", error)
            }
            return
        }

        // Already denied or already prompted this session — do nothing
        if (
            ("Notification" in window &&
                Notification.permission === "denied") ||
            prompted.current
        ) {
            return
        }

        // First notifiable action — request permission
        prompted.current = true
        try {
            const token = await requestPermission()
            if (token) {
                await saveDeviceToken({ token, accessToken: auth.token })
            }
        } catch (error) {
            console.error("Failed to request notification permission:", error)
        }
    }, [auth?.token])

    return { promptAndSaveToken }
}
